module.exports = __webpack_public_path__ + "static/media/bitbang.cf554de1.png";